/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Session } from "./Session";
import * as t from "io-ts";

// required attributes
const SessionResponseR = t.interface({});

// optional attributes
const SessionResponseO = t.partial({
  data: Session
});

export const SessionResponse = t.intersection(
  [SessionResponseR, SessionResponseO],
  "SessionResponse"
);

export type SessionResponse = t.TypeOf<typeof SessionResponse>;
